import { Component, Input } from '@angular/core';

@Component({
  selector: 'zf-text',
  template: `<span [ngClass]="textClasses"><ng-content></ng-content></span>`,
})
export class ZFText {
  @Input() textClasses!: string[];
}
